import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

const StyledCheckboxField = styled("div")`
  width: max-content;
`;

const StyledCheckboxContainer = styled("label")`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  &:hover {
    @media (min-width: 1024px) {
      & .checkbox__custom {
        border-color: ${({ theme }) => theme.palette.green.main};
      }
    }
  }

  & > .checkbox__real {
    display: none;
  }

  & > .checkbox__custom {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 20px;
    height: 20px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.palette.customGrey.soft};
    border: ${({ theme }) => `1px solid ${theme.palette.customGrey.dark}`};
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.25s linear;
    box-sizing: border-box;
  }

  & .checkbox__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(5px);
    opacity: 0;
    transition: all 0.2s ease;

    & svg {
      width: 10px;
      height: 10px;
    }
  }

  & > .checkbox__real:checked ~ .checkbox__custom {
    border-color: ${({ theme }) => theme.palette.green.main};
    background-color: ${({ theme }) => theme.palette.green.main};
  }

  & > .checkbox__real:checked ~ .checkbox__custom .checkbox__icon {
    transform: translateY(0);
    opacity: 1;
    transition: all 0.2s ease;
  }

  &.checkbox_error > .checkbox__custom {
    border-color: ${({ theme }) => theme.palette.red.main};
    background-color: ${({ theme }) => theme.palette.red.light};
  }

  & > .checkbox__real:disabled ~ .checkbox__custom {
    border-color: ${({ theme }) => theme.palette.customGrey.main};
    background-color: ${({ theme }) => theme.palette.customGrey.main};
  }

  & > .checkbox__real:disabled ~ .checkbox__label {
    color: ${({ theme }) => theme.palette.customGrey.main};
  }
`;

const StyledCheckboxLabel = styled(Typography)`
  width: max-content;
  color: ${({ theme }) => theme.palette.common.black};
  font-weight: 300;
  user-select: none;
`;

const StyledCheckboxError = styled(Typography)`
  display: inline-block;
  color: ${({ theme }) => theme.palette.red.main};
  margin-top: 5px;
`;

export {
  StyledCheckboxField,
  StyledCheckboxContainer,
  StyledCheckboxLabel,
  StyledCheckboxError,
};
